<script lang="ts">
const ITEMS_SEARCH_THRESHOLD = 10
</script>
<script setup lang="ts">import { ref as _ref } from 'vue';

import { BaseSearchFilterDto, type CustomMetadataSearchFilterElementDto } from '@/api';
import SearchFilterTreeview from '@/components/SearchFilterTreeview.vue';
/**
 *
 * CustomMetadataFilters
 * Wraps SearchFilterTreeview for Custom Metadata,
 * Proxies the selected values list and dispatches amongst the filters
 *
 */

interface CustomMetadataFiltersProps {
  filters: BaseSearchFilterDto[];
  value: string[];
}

defineProps({
  filters: { default: () => [] },
  value: { default: () => [] }
});

type CustomMetadataFiltersEmits = {
  (event: 'input', items: string[]): void;
}
const emits = defineEmits(["input"]);

// Threshold above which the search bar will be displayed

let localValue = _ref<string[]>([]);

/**
 * Emits selected values:
 * Proxies the selected values, distinct by filter
 * @param values
 */
 const emitValues = (values: string[], filter: BaseSearchFilterDto) => {
  // Remove all the local values that match this filter children
  const filteredLocalValue = localValue.value.filter((v) => !filter.children?.some((child) => (child as CustomMetadataSearchFilterElementDto).id === v));
  // Add the new values
  filteredLocalValue.push(...values);
  localValue.value = filteredLocalValue;
  emits('input', localValue.value);
};

/**
 * Filter the values so that we provide only values that are children of the filter
 * @param value
 * @param filter
 */
const valueByFilterChildren = (value: string[], filter: BaseSearchFilterDto): string[] => {
  if (!filter.children) return [];
  return value.filter((v) => filter.children?.some((child) => (child as CustomMetadataSearchFilterElementDto).id === v));
};

</script>
<template lang="pug">
div
  SearchFilterTreeview(
    v-for="filter in [...filters].sort((a, b) => a.query && b.query ? a.query.localeCompare(b.query) : -1)"
    :key="filter.query"
    :filter="filter"
    :value="valueByFilterChildren(value, filter)"
    :has-search="!!(filter.children?.length && filter.children?.length > ITEMS_SEARCH_THRESHOLD)"
    @input="emitValues($event, filter)"
    expanded
    :tooltip="filter.description"
    data-track="custom-metadata-filter-box" )
</template>
